import script from "./customer.vue?vue&type=script&setup=true&lang=js"
export * from "./customer.vue?vue&type=script&setup=true&lang=js"

import "./customer.vue?vue&type=style&index=0&id=7f71469f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f71469f"]])

export default __exports__